module.exports = __webpack_public_path__ + "static/img/2.89217d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/12/sp/2.png
// module id = CzD3
// module chunks = 0